import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Paediatrician icon
 *
 * @category Medical
 */
const Paediatrician = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M16.222 12.112c2.68-.109 4.663-3.28 3.454-5.73-1.046-2.517-4.576-3.225-6.472-1.22-2.604 2.374-.664 7.081 2.822 6.961h.196zm.098-7.114c3.595.381 3.378 5.981-.294 5.938-3.955-.055-3.835-6.036.087-5.96h.207z"
        />
        <path
          fill="currentColor"
          d="M24.437 12.003c-.338-.25-1.1.131-1.515.349-2.658 1.503-5.284 2.114-8.203 1.852-2.3-.13-4.358-1.187-6.417-2.179-1.493-.327-.534 1.002.49 1.493.773.446 1.656.817 2.473 1.11.61.219 1.177.47 1.285 1.145.164 3.377 0 7.376.066 10.807-.066 1.798 1.111 1.94 1.133.131.033-.882-.011-2.037.033-2.876.043-.621.186-1.045.742-1.11.86-.044 2.395-.107 3.234.09.883.468.294 2.687.447 3.646-.065 1.95 1.177 2.102 1.144.12.032-3.356-.055-7.235.032-10.623.175-1.438 1.863-1.33 2.975-2.026.817-.469 2.092-.905 2.113-1.874l-.043-.066zm-6.668 9.49c-.85.25-2.62.294-3.501 0-.73-.349-.454-1.878-.52-3.327.045-.72-.184-1.729.034-2.393.544-.72 2.094-.43 2.789-.44.694-.01 1.503.465 1.634.944.196 1.144-.044 2.415 0 3.57 0 .784-.065 1.319-.349 1.57l-.098.076z"
        />
      </svg>
    );
  }
);

Paediatrician.displayName = 'Paediatrician';

export { Paediatrician };
